import axios from 'axios';
import toastr from 'toastr';
import Cookie from 'cookies-js';
import config from '../../config/index';
import routes from '../../constants/routes';
import {
  DELETE_CARD_DETAILS_SUCCESS,
} from '../types';

const deleteCard = cardId => ({
  type: DELETE_CARD_DETAILS_SUCCESS,
  cardId
});

const deleteUserCard = cardDetails => (dispatch) => {
  const token = Cookie.get('jwtToken');
  axios.delete(`${config.apiUrl}${routes.DELETEUSERCARD}`, { data: cardDetails }, {
    headers: { Authorization: `Bearer ${token}` }
  })
    .then((response) => {
      const {
        isSuccessful,
      } = response.data;
      console.log('response :', response);
      if (isSuccessful) {
        dispatch(deleteCard(cardDetails.cardId));
        toastr.success('Card successfully deleted');
      }
    }).catch((error) => {
      throw error;
    });
};

export default deleteUserCard;
